import Vue from 'vue';

Vue.prototype.$eventBus = new Vue();

export default Vue.prototype.$eventBus;
